import type { App } from 'vue';
import { FileDownloadManager } from '@precon-tools-suite-by-shared/shared-file-downloads-data-access';
import { DefaultApolloClient } from '@vue/apollo-composable';
import type { TypedGraphQLQueryClient } from '@precon-tools-suite-by-shared/shared-graphql-client-js-generic';
import { fileDownloadManagerInjectionKey } from './symbols';

// Import the global options.

// Export the helpers that you want to use outside of this library.

// Export the composables that you want to use outside of this library.
export { useFileDownloadManager } from './composables/useFileDownloadManager';
export { useFileDownload } from './composables/useFileDownload';

// Export FileDownloadListItemFragment for use in other libraries.
export type { FileDownloadListItemFragment } from './components/FileDownloadListItem.generated';

import FileDownloadListItem from './components/FileDownloadListItem.vue';

export { FileDownloadListItem };

// Import/Export the components that you want to use outside of this library.

// The definition of the plugin that installs the
export default {
    install(app: App, client?: TypedGraphQLQueryClient) {
        client ??= app._context.provides[DefaultApolloClient];
        if (!client)
            throw Error(
                'No GraphQL Client found for @precon-tools-suite-by-shared/shared-file-downloads-feature.'
            );

        const fileDownloadManager = new FileDownloadManager(client);
        app.provide(fileDownloadManagerInjectionKey, fileDownloadManager);
    },
};
